import { render, staticRenderFns } from "./CheckboxView.vue?vue&type=template&id=52d196e3&scoped=true&"
import script from "./CheckboxView.vue?vue&type=script&lang=js&"
export * from "./CheckboxView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d196e3",
  null
  
)

export default component.exports